import ContentLoader from "react-native-easy-content-loader";
import { themeRoundnessMultiplier } from "../../constants";
import { useAppTheme } from "../../useAppTheme";

type Props = {
	numLines?: number;
	height?: number;
};

export const TextSkeleton = ({ numLines = 1, height = 34 }: Props) => {
	const theme = useAppTheme();
	return (
		//@ts-ignore
		<ContentLoader
			paragraphStyles={{
				borderRadius: theme.roundness * themeRoundnessMultiplier,
				overflow: "hidden",
			}}
			containerStyles={{
				paddingHorizontal: 0,
			}}
			active
			title={false}
			pRows={numLines}
			pHeight={height}
			pWidth={"100%"}
		/>
	);
};
